import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { IHttpError } from "types/http";
import NotificationService from "modules/notification/services/notificationService";

import {
  INotificationPayload,
  loadZNSNotification,
  loadZNSNotificationFailed,
  loadZNSNotificationSuccess,
  exportZNSNotification,
} from "./notificationSlice";
import { toastEmitter } from "utils/toast.util";

function* handleLoadZNSNotificationHistory(
  action: PayloadAction<INotificationPayload>
): any {
  try {
    const messages = yield call(
      NotificationService.getErrorsZNSNotification,
      action.payload
    );
    yield put(loadZNSNotificationSuccess(messages));
  } catch (error) {
    yield put(loadZNSNotificationFailed(error as IHttpError));
  }
}

function* handleExportZNSNotification(
  action: PayloadAction<INotificationPayload>
): any {
  try {
    const data = yield call(
      NotificationService.exportZNSNotification,
      action.payload
    );
    const csvContent = data as unknown as string;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", `export-messages-${new Date().toISOString()}.csv`);
    a.click();
    URL.revokeObjectURL(url);
    toastEmitter.show("Export successfully !!", "success");
  } catch (error: any) {
    const msg =
    error?.message || error?.Message || "Export failed. Please try again.";
    toastEmitter.show(msg, "error");
  }
}

export default function* notificationSaga() {
  yield takeLatest(
    loadZNSNotification.toString(),
    handleLoadZNSNotificationHistory
  );
  yield takeLatest(
    exportZNSNotification.toString(),
    handleExportZNSNotification
  );
}
